// 多语言国际化辅助脚本
import { getQueryParam } from './utils';

/** 游戏语言枚举 */
export enum GameLanguage {
    Unknown = 0, // 枚举需与CI18NDefine保持一致
    CHS = 1, // 简体中文
    EN = 2, // 英语
    JA = 3, // 日语
    KO = 4, // 韩语
    CHT = 5, // 繁体中文
    FR = 6, // 法语
    DE = 7, // 德语
    ES = 8, // 西班牙语
    IT = 9, // 意大利语
    TH = 10, // 泰语
    VI = 11, // 越南语
    RU = 12, // 俄语
    TR = 13, // 土耳其语
    PT = 14, // 葡萄牙语
    PT_BR = 15, // 巴西葡萄牙语
    ES_LT = 16, // 拉美西语
    NL = 17, // 荷兰语
    MS = 18, // 马来语
    ID = 19, // 印尼语
    AR = 20, // 阿拉伯语
    HI = 21, // 印地语
    EN_US = 22, // 美式英语
    BN = 23, // 孟加拉语
    MY = 24, // 缅甸语
    LO = 25, // 老挝语
    KM = 26, // 高棉语
    MAX = 27,
}

/** 获取游戏语言ID */
export function getGameLanguageId(lang: string): number {
    lang = lang.toUpperCase();
    let id = GameLanguage[lang];
    if (id == null || id == GameLanguage.MAX) id = GameLanguage.Unknown;
    return id;
}

/** 获取游戏语言名称 */
export function getGameLanguageName(id: number): string {
    let name = GameLanguage[id];
    if (name == null) name = GameLanguage[GameLanguage.Unknown];
    return name;
}

/** 获取对应的语言，data 为对应多语言配置，lang 为想要获取的语言，返回实际对应的语言 */
export function getLanguage(data: LanguageDataType, lang: string): LangType {
    if (data[lang]) return lang as LangType;
    lang = lang.toLowerCase();
    if (data[lang]) return lang as LangType;
    // 不同语言简称兼容
    // 葡语 PTBR/PT
    // ptbr 不存在时使用 pt
    if (lang === 'ptbr') lang = data.pt && 'pt';
    // pt 不存在时使用 ptbr
    else if (lang === 'pt') lang = data['ptbr'] && 'ptbr';
    // 简体 CHS/CN/ZH/ZH-CN
    // cn 不存在时按顺序使用 zh-cn、zh、chs
    else if (lang === 'cn') lang = (data['zh-cn'] && 'zh-cn') || (data['zh'] && 'zh') || (data.chs && 'chs');
    // zh 不存在时按顺序使用 zh-cn、cn、chs
    else if (lang === 'zh') lang = (data['zh-cn'] && 'zh-cn') || (data['cn'] && 'cn') || (data.chs && 'chs');
    // chs 不存在时按顺序使用 zh-cn、zh、cn
    else if (lang === 'chs') lang = (data['zh-cn'] && 'zh-cn') || (data['zh'] && 'zh') || (data['cn'] && 'cn');
    // 繁体 CHT/TC
    else if (lang === 'cht') lang = 'tc';
    else if (lang === 'tc') lang = 'cht';
    // 如果不匹配任何语言，返回默认语言 en
    return (lang || 'en') as LangType;
}

/** 获取本地默认的语言设置，优先从链接参数（默认参数名由 queryParamName 指定，默认为 lang）获取，无法获取时从本地化设置获取，languageData 为支持的多语言配置数据 */
export function getCurrentLanguage(languageData: LanguageDataType, ...queryParamNames: string[]): LangType {
    // 默认参数名为 lang
    if (queryParamNames?.length < 1) queryParamNames = ['lang'];
    let lang: string | undefined;
    for (const n of queryParamNames) {
        lang = getQueryParam(n);
        if (lang) break;
    }
    console.info('[Act] 从链接参数', queryParamNames, '中查找到支持的语言', lang);
    // 如果无法获取则尝试从系统语言中获取
    if (!lang) {
        const allLangs = Object.keys(languageData).map((l) => l.toLowerCase());
        for (let s of navigator.languages) {
            s = s.toLowerCase();
            // 直接包含对应配置的语言
            if (allLangs.indexOf(s) > -1) {
                lang = s;
                break;
            }
            const arr = s.split('-');
            if (arr.length <= 1) continue;
            const l1 = arr[0];
            const l2 = arr.pop();
            // 中文
            if (l1 === 'zh') {
                // 繁体中文
                if (l2 === 'hk' || l2 === 'tw') lang = 'cht';
                // 其它默认简体中文
                else lang = 'chs';
                break;
            }
            // 葡语
            lang = l1;
            break;
        }
        console.info('[Act] 从支持的系统语言', navigator.languages, '中查找到支持的语言', lang);
        if (!lang) lang = 'en';
    }
    return getLanguage(languageData, lang);
}
